export default (baseWidth, baseHeight, viewportWidth, viewportHeight) => {
    let aspectRatio = baseWidth / baseHeight,
        offsetTop = 0,
        offsetLeft = 0,
        scaledWidth = viewportWidth,
        scaledHeight = viewportHeight;

    // when too stretched
    if ((viewportWidth / viewportHeight) > aspectRatio) {

        // get 'correct' height
        scaledHeight = Math.round(viewportWidth / aspectRatio);
        offsetTop = -( scaledHeight - viewportHeight ) / 2;
    }

    if ((viewportWidth / viewportHeight) < aspectRatio) {

        // get 'correct' width
        scaledWidth = Math.round(viewportHeight * aspectRatio);
        offsetLeft = -( scaledWidth - viewportWidth ) / 2;
    }

    return {
        top: offsetTop,
        left: offsetLeft,
        aspectRatio: aspectRatio,
        scaleFactor: scaledWidth / baseWidth,
        scaledWidth: scaledWidth,
        scaledHeight: scaledHeight
    };
};
